import React, { Component } from 'react';
import PropTypes from 'prop-types';
function styleInject(css, ref) {
  if (ref === void 0) ref = {};
  var insertAt = ref.insertAt;
  if (!css || typeof document === 'undefined') {
    return;
  }
  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';
  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}
var css = ".styles_daummap__Vy4iR {\n  width: 100%;\n  height: 100%;\n}\n";
var styles = {
  "daummap": "styles_daummap__Vy4iR"
};
styleInject(css);
var loadScript = function load(src, opts, cb) {
  var head = document.head || document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  if (typeof opts === 'function') {
    cb = opts;
    opts = {};
  }
  opts = opts || {};
  cb = cb || function () {};
  script.type = opts.type || 'text/javascript';
  script.charset = opts.charset || 'utf8';
  script.async = 'async' in opts ? !!opts.async : true;
  script.src = src;
  if (opts.attrs) {
    setAttributes(script, opts.attrs);
  }
  if (opts.text) {
    script.text = '' + opts.text;
  }
  var onend = 'onload' in script ? stdOnEnd : ieOnEnd;
  onend(script, cb);

  // some good legacy browsers (firefox) fail the 'in' detection above
  // so as a fallback we always set onload
  // old IE will ignore this and new IE will set onload
  if (!script.onload) {
    stdOnEnd(script, cb);
  }
  head.appendChild(script);
};
function setAttributes(script, attrs) {
  for (var attr in attrs) {
    script.setAttribute(attr, attrs[attr]);
  }
}
function stdOnEnd(script, cb) {
  script.onload = function () {
    this.onerror = this.onload = null;
    cb(null, script);
  };
  script.onerror = function () {
    // this.onload = null here is necessary
    // because even IE9 works not like others
    this.onerror = this.onload = null;
    cb(new Error('Failed to load ' + this.src), script);
  };
}
function ieOnEnd(script, cb) {
  script.onreadystatechange = function () {
    if (this.readyState != 'complete' && this.readyState != 'loaded') return;
    this.onreadystatechange = null;
    cb(null, script); // there is no way to catch loading errors in IE8
  };
}

var classCallCheck = function classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};
var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var inherits = function inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};
var possibleConstructorReturn = function possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};
var DaumMap = function (_Component) {
  inherits(DaumMap, _Component);
  function DaumMap() {
    classCallCheck(this, DaumMap);
    return possibleConstructorReturn(this, (DaumMap.__proto__ || Object.getPrototypeOf(DaumMap)).apply(this, arguments));
  }
  createClass(DaumMap, [{
    key: 'loadDaumMapScirpt',
    value: function loadDaumMapScirpt(apiKey) {
      return new Promise(function (resolve) {
        return window.daum ? resolve({
          done: true,
          daum: window.daum
        }) : loadScript('https://dapi.kakao.com/v2/maps/sdk.js?&autoload=false&appkey=' + apiKey + '&libraries=services,clusterer,drawing', function (err) {
          return err ? resolve({
            done: false,
            err: err
          }) : resolve({
            done: true,
            daum: window.daum
          });
        });
      });
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
        apiKey = _props.apiKey,
        mapId = _props.mapId,
        render = _props.render;
      this.loadDaumMapScirpt(apiKey).then(function (e) {
        return e.done && render(document.getElementById(mapId), daum);
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var mapId = this.props.mapId;
      return React.createElement('div', {
        id: mapId,
        className: styles.daummap
      });
    }
  }]);
  return DaumMap;
}(Component);
DaumMap.propTypes = {
  apiKey: PropTypes.string.isRequired,
  mapId: PropTypes.string.isRequired,
  render: PropTypes.func.isRequired
};
export default DaumMap;